import React, { SyntheticEvent, useState } from "react";
import { Container, Menu, Image, Dropdown, DropdownMenu, DropdownItem, DropdownDivider } from "semantic-ui-react";
import logo from "../assets/img/logoblanco.svg";
import { useAuth } from "../hooks/AuthProvider";
import {
    USER_ROLE_ADMINISTRATOR,
    USER_ROLE_ADVISOR,
    USER_ROLE_INSTALLER,
    USER_ROLE_LOGISTIC,
    USER_ROLE_ORDERS,
    USER_ROLE_SOCIAL_MEDIA
} from "../utils/constants";
import UpdatePasswordModal from "../pages/users/modals/UpdatePasswordModal";

const Navbar = () => {
    const auth = useAuth();
    const [openModalPassword, setOpenModalPassword] = useState(false);

    const handleLogout = () => {
        auth.logout();
    }

    const handleCancelModalPassword = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModalPassword(false);
    };

    return (
        <Menu fixed="top" size="large" inverted>
            <Container>

                <Menu.Item as="a" href="/" header>
                    <Image size="tiny" src={logo} style={{ marginRight: "1.5em" }} />
                </Menu.Item>

                {auth.userData?.role === USER_ROLE_SOCIAL_MEDIA && (
                    <>
                        <Menu.Item as="a" href="/prospects">Prospectos</Menu.Item>
                    </>
                )}

                {auth.userData?.role === USER_ROLE_ADVISOR && (
                    <>
                        <Menu.Item as="a" href="/assignments">Asignaciones</Menu.Item>
                        <Menu.Item as="a" href="/in-tracing">En seguimiento</Menu.Item>
                        <Menu.Item as="a" href="/completed">Completeados</Menu.Item>
                        <Menu.Item as="a" href="/orders">Ordenes</Menu.Item>
                    </>
                )}

                {auth.userData?.role === USER_ROLE_INSTALLER && (
                    <>
                        <Menu.Item as="a" href="/requests">Pedidos</Menu.Item>
                        <Menu.Item as="a" href="/orders">Ordenes</Menu.Item>
                    </>
                )}

                {auth.userData?.role === USER_ROLE_LOGISTIC && (
                    <>
                        <Menu.Item as="a" href="/orders">Ordenes</Menu.Item>
                        <Menu.Item as="a" href="/reminders">Recordatorio anticipado</Menu.Item>
                        <Menu.Item as="a" href="/unfinished">Proyectos inconclusos</Menu.Item>
                        <Menu.Item as="a" href="/guarantees/adjustments">Ajustes y Garantias</Menu.Item>
                    </>
                )}

                {auth.userData?.role === USER_ROLE_ORDERS && (
                    <>
                        <Menu.Item as="a" href="/requests">Pedidos</Menu.Item>
                        <Menu.Item as="a" href="/orders">Ordenes</Menu.Item>
                        <Menu.Item as="a" href="/reminders">Recordatorio anticipado</Menu.Item>
                    </>
                )}

                {auth.userData?.role === USER_ROLE_ADMINISTRATOR && (
                    <>
                        <Menu.Item as="a" href="/requests">Pedidos</Menu.Item>
                        <Menu.Item as="a" href="/orders">Ordenes</Menu.Item>
                        <Menu.Item as="a" href="/reminders">Recordatorio anticipado</Menu.Item>
                        <Menu.Item as="a" href="/guarantees">Garantias</Menu.Item>
                        <Menu.Item as="a" href="/products">Productos</Menu.Item>
                        <Menu.Item as="a" href="/users">Usuarios</Menu.Item>
                    </>
                )}

                <Dropdown item text={auth.userData?.username} pointing='top right'>
                    <DropdownMenu>
                        <DropdownItem onClick={() => setOpenModalPassword(true)}>Actualizar Contraseña</DropdownItem>
                        <DropdownDivider />
                        <DropdownItem onClick={handleLogout}>Cerrar session</DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                <UpdatePasswordModal
                    userId={auth.userData?.id || ""}
                    openModal={openModalPassword}
                    onClose={handleCancelModalPassword}
                />

            </Container>
        </Menu>
    );
};

export default Navbar;
